// removed by extract-text-webpack-plugin
module.exports = {"segmentedWrapper":"PBH423JDwc5w99dTElNA7","segmentedButton":"_2vqOQ0KmH92-zK8-gSsUk-","active":"_3UG50_TRsGmBSQU0le6ToE","green":"RSXFyiszxQu2nAoanKBb3","gray":"JzeVrhFWRUu_MYnpLMTB9","twoInRow":"_3xS_POu2XhWbZXTMbBsayk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMSegmentedControl/OMSegmentedControl.scss
// module id = 1676
// module chunks = 0